import { render } from "./AddTutorial.vue?vue&type=template&id=77e95c05"
import script from "./AddTutorial.vue?vue&type=script&lang=js"
export * from "./AddTutorial.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Desktop\\all-in-one\\all-in-one-fitness\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__